<template>
    <div
        @mouseover="editing = true"
        @mouseleave="editing = false">
        <div
            v-if="!editing && !shouldDisplayCardContent"
            class="account-visitor-hover-trigger"
            :class="{ 'account-visitor-hover-trigger--table': triggerType === 'table' }">
            <div class="trigger">
                <slot> {{ id }} </slot>
            </div>
        </div>
        <pendo-popover
            v-else
            arrow
            class="account-visitor-hover-trigger"
            :class="{ 'account-visitor-hover-trigger--table': triggerType === 'table' }"
            placement="bottom-start"
            :popover-class="popoverClass"
            :disabled="disabled"
            :delay="400"
            @apply-show="showHandle">
            <slot> {{ id }} </slot>
            <template #popover>
                <account-visitor-card-content
                    v-if="shouldDisplayCardContent"
                    :id="id"
                    ref="accountVisitorCardContent"
                    :kind="kind"
                    :name="name"
                    :visitors-account-name="visitorsAccountName"
                    :visitors-account-id="visitorsAccountId"
                    @modal-visibility-change="handleMetadataModalVisibility" />
            </template>
        </pendo-popover>
    </div>
</template>

<script>
import AccountVisitorCardContent from '@/common/account-visitor-hover-card/account-visitor-card-content/account-visitor-card-content.vue';
import { PendoLoading, PendoPopover } from '@pendo/components';

export default {
    name: 'AccountVisitorHoverCard',
    components: {
        PendoPopover,
        AccountVisitorCardContent,
    },
    directives: {
        PendoLoading,
    },
    props: {
        kind: {
            type: String,
            default: 'account',
        },
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            default: '',
        },
        visitorsAccountId: {
            type: String,
            default: '',
        },
        visitorsAccountName: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        triggerType: {
            type: String,
            default: 'normal',
        },
    },
    data () {
        return {
            triggerShow: false,
            metadataModalOpen: false,
            editing: false,
        };
    },
    computed: {
        popoverClass () {
            return `account-visitor-hover-card${
                this.metadataModalOpen && !this.triggerShow ? '__hide-hover-card' : ''
            }`;
        },
        shouldDisplayCardContent () {
            return this.triggerShow || this.metadataModalOpen;
        },
    },
    methods: {
        async showHandle () {
            if (!this.triggerShow) {
                this.triggerShow = true;
                await this.$nextTick();
            }
            this.$refs.accountVisitorCardContent.showHandle();
        },
        handleMetadataModalVisibility (modalVisible) {
            this.metadataModalOpen = modalVisible;
            if (modalVisible) {
                this.triggerShow = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '@/voc/styles/voc.style.less';

.account-visitor-hover-card {
    border: 1px solid var(--palette-gray-30);
    border-radius: 8px;
    background: var(--palette-gray-0);
    padding: 16px;
    height: 320px;
    box-shadow: 0 4px 8px var(--semantic-drop-shadow-base);
    position: absolute;
    top: 100%;
    left: 0;
}
</style>

<!-- eslint-disable-next-line vue-scoped-css/enforce-style-type -->
<style lang="less">
.account-visitor-hover-trigger {
    text-decoration: inherit;

    .trigger {
        text-decoration: inherit;
        display: initial !important;
    }

    &--table {
        .trigger {
            overflow-x: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            display: flex !important;
        }
    }
}

.account-visitor-hover-card {
    width: 333px;

    .pendo-popover__wrapper {
        padding: 8px;
    }

    &__hide-hover-card {
        display: none !important;
    }
}

.account-visitor-hover-card::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 0px;
    right: 0px;
    bottom: -10px;
}
</style>
